<template>
    <span class="text-danger text-sm">{{ errorMessage }}</span>
</template>

<script>
export default {
  computed: {
    errorMessage : function () {
      if (typeof this.errorsBag[this.fieldName] != "undefined") {
        return this.errorsBag[this.fieldName][0]
      } else {
        return ''
      } 
    }
  },

  props: {
      errorsBag: Object,
      fieldName: String
  }
}
</script>

<style scoped>
</style>
